(function () {
  'use strict';
  var map = window.MunchiesLocalizedImages;
  var alts = window.MunchiesLocalizedImageAlts || {};
  if (!map || !Object.keys(map).length) return;
  var attrs = ['src', 'srcset', 'data-src', 'data-srcset', 'data-full', 'data-image', 'data-zoom', 'poster'];
  function localizeURL(value) {
    if (!value || /^(?:data|blob):/i.test(value)) return value;
    var parsed;
    try { parsed = new URL(value, document.baseURI); } catch (_) { return value; }
    var name;
    try { name = decodeURIComponent(parsed.pathname.split('/').pop()); } catch (_) { return value; }
    var resized = name.match(/^(.*)_(\d+)x(?:\d+)?(\.[^.]+)$/);
    var target = map[name] || (resized && map[resized[1] + resized[3]]);
    if (!target) return value;
    var output = new URL(target);
    ['width', 'height', 'crop', 'format', 'quality'].forEach(function (key) {
      if (parsed.searchParams.has(key)) output.searchParams.set(key, parsed.searchParams.get(key));
    });
    if (resized && !output.searchParams.has('width')) output.searchParams.set('width', resized[2]);
    return output.href;
  }
  function localizeSet(value) {
    if (!value || /data:/i.test(value)) return value;
    return value.split(',').map(function (part) {
      var match = part.trim().match(/^(\S+)(\s+.*)?$/);
      return match ? localizeURL(match[1]) + (match[2] || '') : part;
    }).join(', ');
  }
  function update(element) {
    if (!element || element.nodeType !== 1 || !/^(IMG|SOURCE|A)$/.test(element.tagName)) return;
    var names = element.tagName === 'A' ? ['href'].concat(attrs) : attrs;
    names.forEach(function (name) {
      var current = element.getAttribute(name);
      if (!current) return;
      var next = name.indexOf('srcset') !== -1 ? localizeSet(current) : localizeURL(current);
      if (next !== current) element.setAttribute(name, next);
    });
    if (element.tagName === 'IMG' && element.getAttribute('role') !== 'presentation' && element.getAttribute('aria-hidden') !== 'true') {
      var src = element.getAttribute('src');
      if (src) {
        var key;
        try { key = decodeURIComponent(new URL(src, document.baseURI).pathname.split('/').pop()); } catch (_) { return; }
        if (alts[key] && element.getAttribute('alt') !== alts[key]) element.setAttribute('alt', alts[key]);
      }
    }
  }
  function scan(root) {
    update(root);
    if (root.querySelectorAll) root.querySelectorAll('img,source,a').forEach(update);
  }
  window.MunchiesLocalizeImageURL = localizeURL;
  scan(document);
  if (window.MutationObserver) new MutationObserver(function (changes) {
    changes.forEach(function (change) {
      if (change.type === 'attributes') update(change.target);
      else change.addedNodes.forEach(scan);
    });
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: attrs.concat(['href']) });
}());
